var _style, _defs, _path, _path2, _defs2, _path3, _path4, _defs3, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPopulationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 22.6",
    style: {
      enableBackground: "new 0 0 28 22.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000025428087281403287630000002715012114398196361_);}\r\n\t.st1{clip-path:url(#SVGID_00000095326227551432619490000002576433366292160698_);}\r\n\t.st2{clip-path:url(#SVGID_00000016779481701485017680000010913265871569298091_);}\r\n\t.st3{clip-path:url(#SVGID_00000155842818400973658540000008413380615800276866_);}\r\n\t.st4{clip-path:url(#SVGID_00000167378952712904430880000000292152079358146969_);}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.2,
    y: 6.9,
    width: 10.9,
    height: 12.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132054646147155401160000001462289911710652063_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000132054646147155401160000001462289911710652063_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6,13.6c-3,0-5.5,2.4-5.5,5.5c0,0.2,0.2,0.4,0.4,0.4S1,19.3,1,19.1c0-2.5,2.1-4.6,4.6-4.6c2.5,0,4.6,2.1,4.6,4.6 c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4C11.1,16.1,8.6,13.6,5.6,13.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6,12.9c1.6,0,2.9-1.4,2.9-3c0,0,0,0,0,0c0.1-1.6-1.2-3-2.8-3c0,0,0,0,0,0c-1.6,0-2.9,1.4-2.9,3c0,0,0,0,0,0 C2.7,11.5,4,12.9,5.6,12.9C5.6,12.9,5.6,12.9,5.6,12.9z M5.6,7.7c1.2,0,2.1,1,2,2.2c0,0,0,0,0,0c0,1.2-0.9,2.1-2,2.2c0,0,0,0,0,0 c-1.2,0-2.1-1-2-2.2c0,0,0,0,0,0C3.5,8.7,4.4,7.8,5.6,7.7C5.6,7.7,5.6,7.7,5.6,7.7z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000119829091159776453590000008660444967727447188_",
    x: 8.5,
    y: 3.1,
    width: 10.9,
    height: 12.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021103728084543340540000002238037969687202977_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119829091159776453590000008660444967727447188_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000021103728084543340540000002238037969687202977_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14,9.8c-3,0-5.5,2.4-5.5,5.5c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4c0-2.5,2.1-4.6,4.6-4.6s4.6,2.1,4.6,4.6 c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4C19.5,12.3,17,9.8,14,9.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14,9.1c1.6,0,2.9-1.4,2.9-3c0,0,0,0,0,0c0.1-1.6-1.2-3-2.8-3c0,0,0,0,0,0c-1.6,0-2.9,1.4-2.9,3c0,0,0,0,0,0 C11.1,7.7,12.4,9.1,14,9.1C14,9.1,14,9.1,14,9.1z M14,3.9c1.2,0,2.1,1,2,2.2c0,0,0,0,0,0c0,1.2-0.9,2.1-2,2.2c0,0,0,0,0,0 c-1.2,0-2.1-1-2-2.2c0,0,0,0,0,0C11.9,5,12.8,4,14,3.9C14,3.9,14,3.9,14,3.9z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000059995203205664196880000016690691521154128062_",
    x: 16.9,
    y: 6.9,
    width: 10.9,
    height: 12.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000024704951408047985240000010915567542813632180_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059995203205664196880000016690691521154128062_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000024704951408047985240000010915567542813632180_)"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4,13.6c-3,0-5.5,2.4-5.5,5.5c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4c0-2.5,2.1-4.6,4.6-4.6s4.6,2.1,4.6,4.6 c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4C27.8,16.1,25.4,13.6,22.4,13.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4,12.9c1.6,0,2.9-1.4,2.9-3c0,0,0,0,0,0c0.1-1.6-1.2-3-2.8-3c0,0,0,0,0,0c-1.6,0-2.9,1.4-2.9,3c0,0,0,0,0,0 C19.5,11.5,20.8,12.9,22.4,12.9C22.4,12.9,22.4,12.9,22.4,12.9z M22.4,7.7c1.2,0,2.1,1,2,2.2c0,0,0,0,0,0c0,1.2-0.9,2.1-2,2.2 c0,0,0,0,0,0c-1.2,0-2.1-1-2-2.2c0,0,0,0,0,0C20.3,8.7,21.2,7.8,22.4,7.7C22.4,7.7,22.4,7.7,22.4,7.7z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopulationIcon);
export default __webpack_public_path__ + "static/media/population-icon.6f91f3064176922665f2ddbb06c5f36e.svg";
export { ForwardRef as ReactComponent };